export default __webpack_public_path__ + "static/media/cercuri.05cc0d04.png";